import React from 'react';
import { Route } from 'react-router-dom';
import * as ROUTES from '../constants/routes';
import CampaignScreen from '../screens/CampaignScreen';
import CampaignDetailsScreen from '../screens/CampaignScreen/campaignDetails';
import CreateCampaignScreen from '../screens/CampaignScreen/CreateCampaignScreen';

const CampaignRoutes = () => {
  return (
    <>
      <Route
        path={ROUTES.CAMPAIGN}
        exact
        component={() => <CampaignScreen />}
      />
      <Route
        path={ROUTES.CREATE_CAMPAIGN}
        exact
        component={() => <CreateCampaignScreen />}
      />

      <Route
        path={ROUTES.CAMPAIGN_DETAILS}
        exact
        component={() => <CampaignDetailsScreen />}
      />
    </>
  );
};

export default CampaignRoutes;
